export default "__VITE_ASSET__Dwi6er1H__"